module.exports = __webpack_public_path__ + "static/Group_6247_2x-b5aefa836ad40152e4de0e82a1230a28.png";